import React, { useEffect, useState } from "react";

interface ProgressBarProps {
  startProgress: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ startProgress }) => {
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    if (startProgress) {
      setWidth(100); // Start the progress bar

      // To reset the progress bar back to 0 after it reaches 100%, you can add a setTimeout or another logic here if needed.
    }
  }, [startProgress]);

  return (
    <div className="block bg-[#282B2E] w-full h-4 rounded-2xl overflow-x-hidden">
      <div
        className="block bg-[#F95821] h-full rounded-2xl"
        style={{
          width: `${width}%`,
          transition: "width 40s cubic-bezier(0.82, 0.91, 0.25, 1)",
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
